import CardXl from './card-xl'

export default CardXl
